export default __webpack_public_path__ + "static/media/locationUnavailableMobile.aa2e1719.png";